<template>
  <div>
    <search-bar :backgroundColorGray="true"></search-bar>

    <div class="products-table">
      <div class="container">
        <div class="product-details">
          <h1 class="ident">{{car.manufacturer}} {{car.model}}</h1>

          <!-- <h3>Filtro de Óleo</h3> -->

          <div class="mt-3 text-center">
            <img v-if="car.thumb" :src="url + car.thumb" height="320" alt>
            <img v-else src="../../static/images/prod3.png" height="320" alt>
          </div>

          <h4 class="mt-5">Dados técnicos</h4>
          <div class="prod-info">
            <table class="products">
              <tr>
                <th>Fabricante</th>
                <th>Linha</th>
                <th>Modelo</th>
                <th>Versão</th>
                <th>Ano de</th>
                <th>Ano até</th>
              </tr>
              <tr>
                <td>{{car.manufacturer}}</td>
                <td>{{car.line}}</td>
                <td>{{car.model}}</td>
                <td>{{car.version}}</td>
                <td>{{car.year_from}}</td>
                <td>{{car.year_to}}</td>
              </tr>
            </table>
          </div>

          <span v-for="category in groupedParts">
            <h4 class="mt-5">{{category.categoryName}}</h4>
            <div class="prod-info">
              <table class="products">
                <tr>
                  <th></th>
                  <th>Categoria</th>
                  <th>Código</th>
                  <th>Código Original</th>
                </tr>
                <tr v-for="part in category.parts">
                  <td class="img">
                    <router-link :to="'/produto/' + part.parts.code"></router-link>
                    <img :src="url + part.parts.img" alt>
                    <span>
                      <img :src="url + part.parts.img" alt>
                    </span>
                  </td>
                  <td>{{part.parts.part_subcategory_name}}</td>
                  <td>
                    <div class="d-flex align-items-center">
                    <router-link :class="{'mr-2': part.details}" :to="'/produto/' + part.parts.code">{{part.parts.code}}</router-link>
                    <tooltip v-if="part.details">{{ part.details }}</tooltip>
                    </div>
                  </td>
                  <td>{{part.original ? part.original.equivalence_code : 'N/A'}}</td>
                </tr>
              </table>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div class="diagonal-line"></div>
  </div>
</template>
<script>
import VehicleAPI from "@/api/vehicle.vue";
import PartAPI from "@/api/part.vue";
import { isoToMmYyyy, isoToFullYear } from "@/utils/date.js";

import SearchBar from "@/components/SearchBar.vue";
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "Car",
  components: { SearchBar, Tooltip },
  data() {
    return {
      car: {},
      categories: [],
      groupedParts: [],
      url: "https://static.japanparts.com.br"
    };
  },
  async mounted() {
    await this.loadCar();
    await this.loadCategories();
  },

  methods: {
    async loadCar() {
      this.car = await VehicleAPI.getById(this.$route.params.id);

      let manufObj = await VehicleAPI.getManufacturers(
        this.car.vehicle_manufacturer_id
      );
      this.car.manufacturer = manufObj.name;

      let linesObj = await VehicleAPI.getLines(this.car.vehicle_line_id);
      this.car.line = linesObj.name;

      this.car.year_from = this.formatVehicleYear(this.car.year_from, "<--");
      this.car.year_to = this.formatVehicleYear(this.car.year_to, "-->");

      this.car.parts = await VehicleAPI.getParts(this.$route.params.id);
      await Promise.all(
        this.car.parts.map(async part => {
          let parts = await PartAPI.getById(part.part_id);
          let original = await PartAPI.getEquivalences(part.part_id);
          part.parts = parts[0];
          part.original = original.find(vehicle => vehicle.original == 1);
        })
      );

      //this.car = await VehicleAPI.search(this.$route.params.id);
      //this.car = this.car.data.hits[0];
    },
    async loadCategories() {
      this.categories = await PartAPI.getCategories();
      this.groupPartsByCategory();
    },
    groupPartsByCategory() {
      this.categories.forEach(category => {
        let parts = this.car.parts.filter(part => {
          if (part.parts && part.parts.part_category_id)
            return part.parts.part_category_id === category.id;
          else
            console.info(
              `A parte ID ${part.id} não tem detalhes e não pôde ser exibida.`
            );
        });
        this.groupedParts.push({
          parts,
          categoryName: category.name,
          categoryId: category.id
        });
      });
    },
    formatVehicleYear(date, nullReplacer) {
      if (date) {
        const month = new Date(date).getUTCMonth() + 1;

        if (month === 1) {
          return isoToFullYear(date, nullReplacer);
        }
      }

      return isoToMmYyyy(date, nullReplacer);
    }
  }
};
</script>
<style scoped>
a {
  cursor: pointer;
}
a:not([href]):not([tabindex]) {
  color: #ccb025;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/pages/Car.vue